import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ROOT_URL } from '../../api/ApiConfig';

export const listWorkingHoursApi = createAsyncThunk('co-users/list-working-hours', async ({ id }, { getState, rejectWithValue }) => {
  const { loginToken, loginTokenCoUser } = getState();
  const authToken = loginToken?.response?.token || loginTokenCoUser?.response?.token;
  try {
    const response = await fetch(
      `${ROOT_URL}/co-users/list-working-hours/${id}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`,
        },
      },
    );
    const result = await response.json();
    return result;
  } catch (error) {
    return rejectWithValue(error.response);
  }
});

const initialState = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  isCompleted: false,
  response: [],
  error: null,
};

const listWorkingHours = createSlice(
  {
    name: 'deleteGroup',
    initialState,
    reducers: {},
    extraReducers: {
      [listWorkingHoursApi.pending]: (state) => {
        state.isLoading = true;
      },
      [listWorkingHoursApi.fulfilled]: (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.response = action.payload;
      },
      [listWorkingHoursApi.rejected]: (state, action) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.isError = true;
        state.error = action.payload;
      },
    },
  },
);

export default listWorkingHours;
